import { Module } from 'vuex'

interface SubmissionStatusState {
  chartData: { labelData: string[]; chartData: number[][] }
  chartSeries: any[]
  chartOptions: any
  hasData: boolean
}

export const submissionStatusModule = (): Module<SubmissionStatusState, any> => {
  return {
    namespaced: true,
    state: {
      chartData: { labelData: [], chartData: [] },
      chartSeries: [],
      chartOptions: {},
      hasData: false
    },
    mutations: {
      setChartData(state, chartData: { labelData: string[]; chartData: number[][] }) {
        state.chartData = chartData
      },
      setChartSeries(state, chartSeries: any[]) {
        state.chartSeries = chartSeries
      },
      setChartOptions(state, chartOptions: any) {
        state.chartOptions = chartOptions
      },
      setHasData(state, hasData: boolean) {
        state.hasData = hasData
      }
    },
    actions: {},
    getters: {
      chartData: state => state.chartData,
      chartSeries: state => state.chartSeries,
      chartOptions: state => state.chartOptions,
      hasData: state => state.hasData
    }
  }
}
